import { HostListener, Injectable, } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import {
  PreneedSalesSections, SaleSteps
} from '../../models';

import { BrowserGlobalService } from './browser-global.service';

import { adpModalComponent } from '../../components';
import { ButtonAction, ModalData, SitefinityMenuItem, SitefinityPortalMenu, ADPResourceService as ResourceService } from 'digital-core';

@Injectable()
export abstract class ComponentCanDeactivate {

  abstract canDeactivate(): boolean;

  @HostListener('window:popstate', ['$event'])
  unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}

@Injectable()

export class DeactivateGuardService  {
  showDashboard = false;
  islogout: any;
  salesStep: number;
  preneedLastSection = 0;
  menuitem: SitefinityPortalMenu;

  constructor(private next: ActivatedRoute, private resourceService: ResourceService,
    private matDialog: MatDialog, private browserGlobalService: BrowserGlobalService, private route: Router) { }
  async canDeactivate(component: ComponentCanDeactivate, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Promise<boolean> {

    // if canDeactivate is not defined return true
    if (!component.canDeactivate) { return true; }

    if (!component.canDeactivate()) {

      if (this.browserGlobalService.GlobalLogout === 'logout') {
        this.browserGlobalService.GlobalLogout = '';
        return true;
      }

      // Get Portal left menus from sitefinity.
      const menues = await this.resourceService.getPortalMenus("Menu").toPromise();
      this.menuitem = menues;
      // this.resourceService.getPortalMenus("Portal_Left_Menu").subscribe((response)=>{
      //  this.menuitem = response;
      // });

      const str: SitefinityMenuItem[] = this.menuitem.MenuItems.filter((m) => { return m.LinkUrl.includes(nextState.url) && m.Hidden === false });

      if (nextState.url !== '/sales' && nextState.url === (str.length > 0 ? str[0].LinkUrl : '')) { return true; }

      this.salesStep = SaleSteps.Review;
      this.preneedLastSection = PreneedSalesSections.ReviewAndSignStep;


      if (this.browserGlobalService.PreneedLastSavedSection === this.preneedLastSection || this.browserGlobalService.PreneedLastSavedSection === this.salesStep) {
        history.pushState("", "", "/sales");
        this.browserGlobalService.callComponentMethod("")
        return false;
      }

      // Pushing url in history resolves the routing issue on the same url
      history.pushState("", "", "/sales");
      let modalData = new ModalData();
      modalData.Header = this.resourceService.getViewLabel("Global_Text_ModalHeader_BrowserBack");
      modalData.Body = this.resourceService.getViewLabel("Global_Text_ModalBody_BrowserMessage");
      modalData.ControlArray = [
        new ButtonAction(this.resourceService.getViewLabel("Global_Text_ModalCancel_Yes"), "YES"),
        new ButtonAction(this.resourceService.getViewLabel("Global_Text_ModalCancel_No"), "NO")
      ];
      let dialogRef = this.matDialog.open(adpModalComponent, {
        data: modalData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.toLowerCase() === "yes") {
          this.browserGlobalService.callComponentMethod("");
          return false;
        }
        return false;
      });
    }
    return false;
  }
}
